import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-referral-selection',
  templateUrl: './referral-selection.component.html',
  styleUrls: ['./referral-selection.component.scss']
})
export class ReferralSelectionComponent
{
  @Output() public selectedNewReferralType = new EventEmitter<string>();
  @Output() public closeNewReferralType = new EventEmitter<string>();

  public newReferralForm: any;
  public newReferralDialogOpened = false;

  constructor(private fb: UntypedFormBuilder) { }

  public get newReferralType(): UntypedFormControl
  {
    return this.newReferralForm.get('newReferralType');
  }

  @Input() public set dialogOpened(value: boolean)
  {
    if (value)
    {
      this.buildForm();
    }
  }

  /**
   * Close the modal
   */
  public closeModal(): void
  {
    this.hideModal();
    this.closeNewReferralType.emit();
  }

  /**
   * New Referral Type selected
   */
  public onSelectedNewReferralType(): void
  {
    this.hideModal();
    this.selectedNewReferralType.emit(this.newReferralType.value);
  }

  /**
   * Create new referral type form.
   */
  private buildForm(): void
  {
    this.newReferralForm = this.fb.group({ newReferralType: [null, Validators.required] });
    this.newReferralDialogOpened = true;
  }

  private hideModal(): void
  {
    document.body.style.overflow = '';
    this.newReferralDialogOpened = false;
  }
}
